module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c4IDP"))).then(() => module.bundle.root('d0iPb'));